module.exports = __webpack_public_path__ + "img/resources3.f21ddab6.jpg";